import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
interface AppLayoutProps {
  children: React.ReactNode;
}
export function AppLayout({
  children
}: AppLayoutProps) {
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-14">
      {/* Sidebar - Desktop */}
      <Sidebar data-id="element-15" />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-16">
        {/* Header */}
        <Header data-id="element-17" />

        {/* Page Content */}
        <main className="flex-1 overflow-auto pb-16 md:pb-0" data-id="element-18">{children}</main>
      </div>

      {/* Mobile Navigation */}
      <MobileNav data-id="element-19" />
    </div>;
}